import { BotAction } from "./BotAction";
import { Icon } from "@zapier/design-system";
import { useChatbotContext } from "./ChatbotContext";

type CopyBotMessageProps = {
  message: { content?: string };
  buttonText: string;
  onClick: () => void;
};

export function CopyBotMessage({
  message,
  buttonText,
  onClick,
}: CopyBotMessageProps) {
  const { emitConsumerInteractionEvent, projectId, pageId, isEmbedded } =
    useChatbotContext();
  return (
    <BotAction
      type="button"
      onClick={() => {
        navigator.clipboard
          .writeText(message.content ? message.content : "")
          .catch((err) => {
            console.warn("Failed to copy text: ", err);
          })
          .finally(() => {
            // we always want to emit the event, even if the copy fails
            emitConsumerInteractionEvent?.({
              interaction_goal: "copy bot response",
              event_action: "click",
              interfaces_project_id: projectId,
              interfaces_page_id: pageId,
              interfaces_component_type: "chatbot",
              embedded_flag: isEmbedded,
            });
            // we always want to call onClick, even if the copy fails
            onClick();
          });
      }}
    >
      <Icon name="actionCopy" size={17} />
      {buttonText}
    </BotAction>
  );
}
